module.exports = __webpack_public_path__ + "static/media/Nokia 220 Blue.0ad936b2.png";